import { motion } from 'framer-motion';
import React from 'react';
import Book from '@/assets/images/page/book.react.svg?react';
import Box from '@/assets/images/page/box.react.svg?react';
import Cactus from '@/assets/images/page/cactus.react.svg?react';
import CenterDesk from '@/assets/images/page/center-desk.react.svg?react';
import CenterMonitor from '@/assets/images/page/center-monitor.react.svg?react';
import CenterText from '@/assets/images/page/center-text.react.svg?react';
import Chair from '@/assets/images/page/chair.react.svg?react';
import Clock from '@/assets/images/page/clock.react.svg?react';
import Cola from '@/assets/images/page/cola.react.svg?react';
import Computer from '@/assets/images/page/computer.react.svg?react';
import Cup from '@/assets/images/page/cup.react.svg?react';
import Doll from '@/assets/images/page/doll.react.svg?react';
import Fan from '@/assets/images/page/fan.react.svg?react';
import Fries from '@/assets/images/page/fries.react.svg?react';
import Hamburger from '@/assets/images/page/hamburger.react.svg?react';
import LeftDesk from '@/assets/images/page/left-desk.react.svg?react';
import LeftMan from '@/assets/images/page/left-man.react.svg?react';
import LeftMonitorOne from '@/assets/images/page/left-monitor-one.react.svg?react';
import LeftMonitorTwo from '@/assets/images/page/left-monitor-two.react.svg?react';
import LeftText from '@/assets/images/page/left-text.react.svg?react';
import Mouse from '@/assets/images/page/mouse.react.svg?react';
import Pen from '@/assets/images/page/pen.react.svg?react';
import RightDesk from '@/assets/images/page/right-desk.react.svg?react';
import RightMan from '@/assets/images/page/right-man.react.svg?react';
import RightMonitor from '@/assets/images/page/right-monitor.react.svg?react';
import RightText from '@/assets/images/page/right-text.react.svg?react';
import Vase from '@/assets/images/page/vase.react.svg?react';
import Vector560 from '@/assets/images/page/vector560.react.svg?react';
import Vector561 from '@/assets/images/page/vector561.react.svg?react';
import Vector562 from '@/assets/images/page/vector562.react.svg?react';
import Vector563 from '@/assets/images/page/vector563.react.svg?react';
import Vector564 from '@/assets/images/page/vector564.react.svg?react';
import Vector565 from '@/assets/images/page/vector565.react.svg?react';
import Vector566 from '@/assets/images/page/vector566.react.svg?react';
import Woman from '@/assets/images/page/woman.react.svg?react';
import styles from './homeAnimation.module.scss';
export const HomeAnimation = () => (<motion.div className={styles.content}>
    <div className={styles.left}>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 0, right: 0, zIndex: 5 }}>
        <LeftDesk/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.3, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 130, zIndex: 3 }}>
        <LeftMonitorOne/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.5, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 20, zIndex: 3 }}>
        <LeftMonitorTwo/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.5, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 328, zIndex: 4 }}>
        <Cola/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.55, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 314, zIndex: 3 }}>
        <Fries/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.58, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 343, zIndex: 5 }}>
        <Hamburger/>
      </motion.div>
      <motion.div initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3, delay: 0.58 }}
                  style={{ position: 'absolute', bottom: 114, right: 85, zIndex: 5 }}>
        <Mouse/>
      </motion.div>
      <motion.div initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3, delay: 0.8 }}
                  style={{ position: 'absolute', bottom: 0, right: 191.3, zIndex: 5 }}>
        <Chair/>
      </motion.div>
      <motion.div initial={{ opacity: 0, x: -200 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: 0.8 }}
                  style={{ position: 'absolute', bottom: 0, right: 65.5, zIndex: 6 }}>
        <LeftMan/>
      </motion.div>
      <div className={styles.leftText}>
        <LeftText />
      </div>
    </div>
    <div className={styles.center}>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.2, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 0, left: 0, zIndex: 5 }}>
        <CenterDesk/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.5, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 17, zIndex: 5 }}>
        <Cactus/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.5, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 57, zIndex: 6 }}>
        <Computer/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.8, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, right: 94, zIndex: 5 }}>
        <CenterMonitor/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 1.6, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 0, left: 324.4, zIndex: 6 }}>
        <Woman/>
      </motion.div>
      <div className={styles.centerText}>
        <CenterText/>
      </div>
    </div>
    <div className={styles.right}>
      <motion.div initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.4, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 0, right: 103, zIndex: 5 }}>
        <RightDesk/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: 0.7, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 25, zIndex: 5 }}>
        <Pen/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: 0.9, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 54, zIndex: 5 }}>
        <Book/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: 1.1, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 102, zIndex: 5 }}>
        <RightMonitor/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: 1.1, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 114, left: 351, zIndex: 5 }}>
        <Cup/>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: -30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: 1.3, type: 'spring', damping: 9 }}
                  style={{ position: 'absolute', bottom: 0, left: 250, zIndex: 6 }}>
        <RightMan/>
      </motion.div>
      <div className={styles.rightText}>
        <RightText/>
      </div>
    </div>
  <div className={styles.animateBottom}>
    <motion.div initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5 }} className={styles.floor}/>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, left: -25, zIndex: 2 }}>
      <Vector562/>
    </motion.div>

    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 30, left: 90 }} >
      <Vector563/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, left: 220 }}>
      <Vector564/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, right: 0 }}>
      <Vector561/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, right: 340 }}>
      <Vector565/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, left: 605 }}>
      <Vector566/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ position: 'absolute', bottom: 0, right: 60 }}>
      <Vector560/>
    </motion.div>

    <motion.div initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 1.5, type: 'spring' }}
                style={{ position: 'absolute', bottom: 283.95, left: 80 }}>
      <Clock/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                style={{ position: 'absolute', bottom: 0, left: 560 }}>
      <Vase/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                style={{ position: 'absolute', bottom: 0, left: 690, zIndex: 3 }}>
      <Doll/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                style={{ position: 'absolute', bottom: 0, left: 736, zIndex: 2  }}>
      <Box/>
    </motion.div>
    <motion.div initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                style={{ position: 'absolute', bottom: 0, right: 40  }}>
      <Fan/>
    </motion.div>
  </div>
</motion.div>);

